import { render, staticRenderFns } from "./MServiceOpening.vue?vue&type=template&id=547ad835&scoped=true&"
import script from "./MServiceOpening.vue?vue&type=script&lang=ts&"
export * from "./MServiceOpening.vue?vue&type=script&lang=ts&"
import style0 from "./MServiceOpening.vue?vue&type=style&index=0&id=547ad835&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547ad835",
  null
  
)

export default component.exports